var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationAlertDark24X24({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24x24/notification_alert_dark24x24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7623 11.952C20.0478 13.221 20.4389 14.1683 20.8143 14.8566C21.1712 15.5109 21.5194 15.9413 21.7626 16.198C21.8845 16.3267 21.9807 16.4124 22.0394 16.4614C22.0688 16.4858 22.0888 16.5011 22.0979 16.5079L22.1024 16.5112C22.4613 16.7574 22.6202 17.2081 22.4938 17.6256C22.3661 18.0474 21.9774 18.3358 21.5367 18.3358H2.33333C1.89266 18.3358 1.50394 18.0474 1.37624 17.6256C1.24982 17.2081 1.40873 16.7574 1.76767 16.5112L1.77213 16.5079C1.7813 16.5011 1.80131 16.4858 1.83067 16.4614C1.88937 16.4124 1.98559 16.3267 2.10747 16.198C2.3507 15.9413 2.69885 15.5109 3.05572 14.8566C3.76669 13.5532 4.5339 11.3208 4.5339 7.73414C4.5339 5.77124 5.31366 3.88873 6.70164 2.50075C8.08962 1.11277 9.97213 0.333008 11.935 0.333008C13.1557 0.333008 14.3453 0.634562 15.4042 1.19642C14.8405 1.61906 14.3536 2.13861 13.9683 2.73035C13.3286 2.47041 12.6389 2.33301 11.935 2.33301C10.5026 2.33301 9.12876 2.90205 8.11585 3.91496C7.10294 4.92787 6.5339 6.30167 6.5339 7.73414C6.5339 11.6155 5.70082 14.1839 4.81151 15.8143C4.70983 16.0008 4.60769 16.1744 4.50635 16.3358H19.3637C19.2624 16.1744 19.1602 16.0008 19.0586 15.8143C18.5325 14.8499 18.0261 13.5573 17.7002 11.8588C18.1187 11.9513 18.5537 12 19 12C19.2582 12 19.5126 11.9837 19.7623 11.952Z",
    fill: "#2B303C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58763 20.7387C10.0654 20.4616 10.6773 20.6242 10.9544 21.1019C11.0541 21.2737 11.1971 21.4163 11.3692 21.5154C11.5413 21.6146 11.7364 21.6668 11.9351 21.6668C12.1337 21.6668 12.3288 21.6146 12.5009 21.5154C12.673 21.4163 12.8161 21.2737 12.9157 21.1019C13.1928 20.6242 13.8048 20.4616 14.2825 20.7387C14.7602 21.0158 14.9228 21.6277 14.6457 22.1055C14.3702 22.5803 13.9749 22.9745 13.4991 23.2485C13.0234 23.5225 12.4841 23.6668 11.9351 23.6668C11.3861 23.6668 10.8467 23.5225 10.371 23.2485C9.89526 22.9745 9.49987 22.5803 9.2244 22.1055C8.94728 21.6277 9.1099 21.0158 9.58763 20.7387Z",
    fill: "#2B303C"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "indicator dot",
    cx: 19,
    cy: 6,
    r: 4,
    fill: "#FF5900"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationAlertDark24X24);
export default __webpack_public_path__ + "static/media/notification_alert_dark24x24.9b14f2929f48be80bcfeee2f5777699e.svg";
export { ForwardRef as ReactComponent };